import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export default function archiveMultipleStudent(schoolId, studentIdList) {

  if(!schoolId){
    throw new Error('missing school ID');
  }

  if (!Array.isArray(studentIdList) || studentIdList.length == 0) {
    throw new Error('studentIdList must be a non-empty array.');
  }

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/multi_stu_archive/${schoolId}/`,
		'method': 'PUT',
      'data': JSON.stringify({
        student_id_list: studentIdList,
       }),
		'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/student/archiveMultipleStudents.js